import { Injectable } from '@angular/core';
import { EstadoCacheBiometricoLocal } from './servico-cache-biometrico-local';

export interface EstadoCacheBiometricoRegistrador {
  cacheBiometricoValido: boolean;
  totalFuncionariosCache: number;
}

@Injectable({ providedIn: 'root' })
export class ServicoEstadoCacheBiometricoRegistrador {
  vazio(): EstadoCacheBiometricoRegistrador {
    return {
      cacheBiometricoValido: false,
      totalFuncionariosCache: 0
    };
  }

  doEstadoLocal(estado: EstadoCacheBiometricoLocal): EstadoCacheBiometricoRegistrador {
    return {
      cacheBiometricoValido: estado.valido,
      totalFuncionariosCache: estado.totalFuncionarios
    };
  }
}
